import MDButton from 'components/MDButton'
import React, { useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage, useUploadImages } from 'hook/services'
import { Button, Stack } from '@mui/material'
import Editor from 'components/editor'


const CreateModal = ({ handleRefresh }) => {
  const uploadImage = useUploadImage()
  const uploadImage2 = useUploadImages()


  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')
  const handleModal = () => {
    setOpenAddProduct(true)
  }


  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }




  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    let image_response;
    let image_responses;

    if (e.target?.image?.files?.[0]) {
      image_response = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      });
    }

    if (e.target?.company_logo?.files?.[0]) {
      image_responses = await uploadImage2({
        file: e.target?.company_logo?.files?.[0],
        desiredPath: `app/logo/image`,
      });
    }


    const payload = {
      name: e.target.name.value,
      description,
      start_date: e.target.start_date.value,
      end_date: e.target.end_date.value,
      ticket_link: e.target.ticket_link.value,
      site_link: e.target.site_link.value,
      image: image_response?.response?.data || "",
      company_logo: image_responses?.response?.data || "",
    };


    console.log(payload, "payload");

    const { response } = await AppService.Event.create({ payload });

    if (response) {
      setProcessing(false);
      closeAddProduct();
      handleRefresh();
    }
  };



  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style} >
            <MDTypography variant="h5" mb={2}>
              Create Event
            </MDTypography>



            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Start Date</MDTypography>
              <MDInput type="date" name="start_date" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">End Date</MDTypography>
              <MDInput type="date" name="end_date" fullWidth />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Ticket Link</MDTypography>
              <MDInput label="Ticket Link" name="ticket_link" fullWidth />
            </MDBox>






            <MDBox mb={2}>
              <MDTypography variant="button">Site Link</MDTypography>
              <MDInput label="Site Link" name="site_link" fullWidth />
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }} fullWidth>
                Upload Profile Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>


            <Stack direction="row" alignItems="center" spacing={2} style={{ marginTop: 10 }}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }} fullWidth>
                Upload Cover Image +
                <input hidden name="company_logo" type="file" />
              </Button>
            </Stack>




            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal
